var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-creative-content"},[_c('div',{staticClass:"inner-wrapper"},[_c('h2',[_vm._v("204")]),_c('p',[_vm._v("عذراً.. "),_c('br'),_vm._v(" المحتوى غير موجود أو قد تم حذفه")]),_c('a',{staticClass:"back-button solid-button-one",attrs:{"href":"/"}},[_vm._v("العودة للرئيسية")])])])
}]

export { render, staticRenderFns }